import axios from 'axios';

/**
 * In development, set REACT_APP_INTERSTELLAR_USE_PROXY=true so requests go to the same
 * origin (CRA dev server) and are forwarded via package.json "proxy" — avoids CORS.
 * curl has no CORS, so it can work while the browser fails without proxy or server CORS.
 */
const USE_DEV_PROXY = process.env.REACT_APP_INTERSTELLAR_USE_PROXY === 'true';
const INTERSTELLAR_URL = USE_DEV_PROXY
  ? ''
  : process.env.REACT_APP_INTERSTELLAR_URL || 'http://localhost:8001';
const INTERSTELLAR_API_KEY = process.env.REACT_APP_INTERSTELLAR_API_KEY || '';

const interstellarApi = axios.create({
  baseURL: INTERSTELLAR_URL,
  headers: {
    Accept: 'application/json',
  },
});

interstellarApi.interceptors.request.use(
  (config) => {
    if (config?.headers) {
      // Match Interstellar / curl: X-Api-Key (browsers normalize header names anyway)
      // eslint-disable-next-line no-param-reassign
      config.headers['X-Api-Key'] = INTERSTELLAR_API_KEY;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default interstellarApi;
